/* Instant quote page: upload → measure → price → 3D preview → cart. */
(function () {
  'use strict';
  var E = window.LSEngine;
  if (!E || !document.getElementById('qparts')) return;
  var R = E.RATES;
  var Store = window.LSStore;
  var ROUTES = window.LS_ROUTES || { checkout: 'checkout.html' };
  var SHOP = window.LS_SHOP || null; // set on the Shopify theme: store root + Storefront API version
  if (SHOP) SHOP.root = (SHOP.root || '/').replace(/\/?$/, '/');
  var $ = function (id) { return document.getElementById(id); };
  var els = {
    drop: $('qdrop'), file: $('qfile'), status: $('qstatus'), parts: $('qparts'),
    viewer: $('qviewer'), empty: $('qviewer-empty'), hud: $('qhud'),
    ship: $('qship'), lines: $('qlines'), total: $('qtotal'), checkout: $('qcheckout'),
    save: $('qsave'), email: $('qemail'), saved: $('qsaved'), defaultNote: $('qdefault')
  };
  var state = { parts: [], active: null, tier: 'standard', defaultMaterial: 'pa12', seq: 0 };
  var MAX_BYTES = 100 * 1024 * 1024;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var V = null;

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmtMM(v) { return v >= 100 ? v.toFixed(0) : v.toFixed(1); }
  function newUid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
  function find(id) { for (var i = 0; i < state.parts.length; i++) if (state.parts[i].id === id) return state.parts[i]; return null; }
  function clampQty(v) { var n = Math.floor(+v); return isFinite(n) && n >= 1 ? Math.min(n, 5000) : 1; }
  function status(text, kind) {
    if (!text) { els.status.hidden = true; return; }
    els.status.hidden = false;
    els.status.className = 'notice ' + (kind || 'info');
    els.status.textContent = text;
  }

  /* ---------- parts ---------- */
  function addPart(name, positions, opts) {
    opts = opts || {};
    var base = E.analyze(positions);
    if (!base.triangles) throw new Error(name + ' has no triangles to measure.');
    var p = {
      id: 'p' + (++state.seq), uid: newUid(), name: name, sample: opts.sample || null, positions: positions, base: base,
      buffer: opts.buffer || null, unit: 'mm', geo: E.scaledGeo(base, 'mm'), materialId: opts.materialId || state.defaultMaterial,
      finishId: 'standard', qty: 1
    };
    if (p.buffer && Store && Store.putPart) Store.putPart(p.uid, name, p.buffer).catch(function () {});
    state.parts.push(p);
    state.active = p.id;
    persist();
    render();
    showActive();
    return p;
  }

  function handleFiles(list) {
    var files = Array.prototype.slice.call(list || []);
    var i = 0;
    (function next() {
      if (i >= files.length) return;
      var f = files[i++];
      if (f.size > MAX_BYTES) { status(f.name + ' is over 100 MB. Lower the mesh resolution, or send it as a special request.', 'bad'); return next(); }
      status('Reading ' + f.name + '…');
      f.arrayBuffer().then(function (buf) { return handleBuffer(f.name, buf); }).then(next, function (err) {
        status(err && err.message ? err.message : String(err), 'bad');
        next();
      });
    })();
  }

  function handleBuffer(name, buf) {
    var ext = (name.split('.').pop() || '').toLowerCase();
    status('Measuring ' + name + '…');
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        try {
          if (ext === 'stl') { addPart(name, E.parseSTL(buf), { buffer: buf }); done(); }
          else if (ext === 'obj') { addPart(name, E.parseOBJ(new TextDecoder().decode(buf)), { buffer: buf }); done(); }
          else if (ext === '3mf') { E.parse3MF(buf, window.JSZip).then(function (pos) { addPart(name, pos, { buffer: buf }); done(); }, reject); }
          else if (['step', 'stp', 'iges', 'igs'].indexOf(ext) >= 0) {
            reject(new Error('STEP and IGES files are converted on our server in the full build. For this demo, export an STL, OBJ or 3MF, or send the file as a special request.'));
          } else reject(new Error(name + ' isn’t a 3D file we can read. Upload an STL, OBJ or 3MF.'));
        } catch (e) { reject(e); }
        function done() { status(''); resolve(); }
      }, 30);
    });
  }

  function addSample(key, materialId) {
    var s = E.SAMPLES[key];
    if (!s) return;
    addPart(s.name, s.make(), { sample: key, materialId: materialId || s.material });
  }

  /* ---------- cart persistence (geometry summary only; meshes stay in memory) ---------- */
  function persist() {
    Store.save(window.LS_CART_KEY, {
      tier: state.tier, savedAt: Date.now(),
      parts: state.parts.map(function (p) {
        return { uid: p.uid, name: p.name, sample: p.sample, unit: p.unit, base: p.base, materialId: p.materialId, finishId: p.finishId, qty: p.qty };
      })
    });
    if (window.LSUpdateBadge) window.LSUpdateBadge();
  }

  function restore() {
    var cart = Store.load(window.LS_CART_KEY, null);
    if (!cart || !cart.parts || !cart.parts.length) return;
    state.tier = R.tiers[cart.tier] ? cart.tier : 'standard';
    cart.parts.forEach(function (c) {
      var pos = c.sample && E.SAMPLES[c.sample] ? E.SAMPLES[c.sample].make() : null;
      var base = pos ? E.analyze(pos) : c.base;
      if (!base || !base.size) return;
      var unit = c.unit || 'mm';
      state.parts.push({
        id: 'p' + (++state.seq), uid: c.uid || newUid(), name: c.name, sample: c.sample || null, positions: pos, buffer: null, base: base, unit: unit,
        geo: E.scaledGeo(base, unit), materialId: R.materials[c.materialId] ? c.materialId : 'pa12',
        finishId: c.finishId || 'standard', qty: clampQty(c.qty)
      });
    });
    if (state.parts.length) state.active = state.parts[state.parts.length - 1].id;
  }

  /* reload the original files of restored uploads, so the preview and checkout have them again */
  function hydrate() {
    if (!Store || !Store.getPart) return;
    state.parts.forEach(function (p) {
      if (p.positions || p.sample || !p.uid) return;
      Store.getPart(p.uid).then(function (rec) {
        if (!rec || !rec.buffer) return;
        p.buffer = rec.buffer;
        var ext = (p.name.split('.').pop() || '').toLowerCase();
        var done = function (pos) { p.positions = pos; if (state.active === p.id) showActive(); };
        try {
          if (ext === 'stl') done(E.parseSTL(rec.buffer));
          else if (ext === 'obj') done(E.parseOBJ(new TextDecoder().decode(rec.buffer)));
          else if (ext === '3mf' && window.JSZip) E.parse3MF(rec.buffer, window.JSZip).then(done, function () {});
        } catch (e) { /* keep the saved price; the preview just stays empty */ }
      }).catch(function () {});
    });
  }

  /* ---------- rendering ---------- */
  function priceBits(p) {
    var m = R.materials[p.materialId];
    var price = E.pricePart(p.geo, p.materialId, p.finishId, p.qty, state.tier);
    var b = 'Material ' + E.money(price.parts.material) + ' + machine space ' + E.money(price.parts.space) + ' + handling ' + E.money(price.parts.handling);
    if (price.parts.finish) b += ' + finish ' + E.money(price.parts.finish);
    if (price.minimumApplied) b += ', raised to the ' + E.money(m.minPart) + ' part minimum';
    if (price.discount) b += ' · ' + Math.round(price.discount * 100) + '% quantity discount';
    if (price.leadMultiplier !== 1) b += ' · ' + R.tiers[state.tier].name + ' ×' + price.leadMultiplier.toFixed(2);
    return { price: price, breakdown: b };
  }

  function cardHTML(p) {
    var g = p.geo, m = R.materials[p.materialId];
    var bits = priceBits(p);
    var issues = E.checks(g, p.materialId);
    var matOpts = R.materialOrder.map(function (id) {
      var mm = R.materials[id];
      var fit = E.fits(g.size, mm.maxDims);
      return '<option value="' + id + '"' + (id === p.materialId ? ' selected' : '') + '>' + esc(mm.short + ' · ' + mm.process + (fit ? '' : ' (too large)')) + '</option>';
    }).join('');
    var finOpts = m.finishes.map(function (fid) {
      var label = R.finishes[fid].name + (fid === 'vapor' && p.materialId === 'pa11cf' ? ' (pilot)' : '');
      return '<option value="' + fid + '"' + (fid === p.finishId ? ' selected' : '') + '>' + esc(label) + '</option>';
    }).join('');
    var dims = g.size.map(fmtMM).join(' × ') + ' mm · ' + (g.volume / 1000).toFixed(2) + ' cm³ · ' + g.triangles.toLocaleString('en-US') + ' triangles';
    var water = g.watertight === null ? '' : g.watertight
      ? '<span class="tag good"><span class="dot"></span>Watertight</span>'
      : '<span class="tag warn"><span class="dot"></span>Needs repair</span>';
    var units = ['mm', 'in', 'cm'].map(function (u) {
      return '<button type="button" data-unit="' + u + '" aria-pressed="' + (p.unit === u) + '">' + u + '</button>';
    }).join('');
    return '<article class="part' + (p.id === state.active ? ' active' : '') + '" data-id="' + p.id + '">' +
      '<div class="part-top"><div style="min-width:0"><button type="button" class="part-name" data-act="view">' + esc(p.name) + '</button>' +
      '<div class="part-dims">' + esc(dims) + '</div></div>' +
      '<div class="row" style="gap:.4rem;flex:none">' + water + '<span class="unit-toggle" role="group" aria-label="Units the file was drawn in">' + units + '</span></div></div>' +
      '<div class="part-controls">' +
      '<div class="field"><label for="m-' + p.id + '">Material</label><select id="m-' + p.id + '" data-act="material">' + matOpts + '</select></div>' +
      '<div class="field"><label for="f-' + p.id + '">Finish</label><select id="f-' + p.id + '" data-act="finish">' + finOpts + '</select></div>' +
      '<div class="field qty"><label for="q-' + p.id + '">Qty</label><input id="q-' + p.id + '" type="number" min="1" max="5000" step="1" inputmode="numeric" value="' + p.qty + '" data-act="qty"></div>' +
      '</div>' +
      (issues.length ? '<ul class="issues">' + issues.map(function (x) { return '<li class="' + x.level + '">' + esc(x.text) + '</li>'; }).join('') + '</ul>' : '') +
      '<div class="part-bottom"><p class="small muted" style="max-width:36ch" data-breakdown>' + esc(bits.breakdown) + '</p>' +
      '<div class="part-price"><strong data-line>' + E.money(bits.price.line) + '</strong><span data-each>' + E.money(bits.price.unit) + ' each</span></div></div>' +
      '<div class="row" style="justify-content:space-between"><span class="tiny muted">' + esc(m.machine) + ' · ' + esc(m.color) + '</span>' +
      '<button type="button" class="linkish" data-act="remove">Remove</button></div>' +
      '</article>';
  }

  function render() {
    var focusId = document.activeElement && document.activeElement.id;
    if (!state.parts.length) {
      els.parts.innerHTML = '<div class="panel"><h3>No parts yet</h3><p>Drop STL, OBJ or 3MF files above, or load a sample part to see how pricing works.</p></div>';
    } else {
      els.parts.innerHTML = state.parts.map(cardHTML).join('');
    }
    renderSummary();
    if (focusId) { var el = document.getElementById(focusId); if (el) el.focus(); }
  }

  function lines() {
    return state.parts.map(function (p) { return { geo: p.geo, materialId: p.materialId, finishId: p.finishId, qty: p.qty }; });
  }

  function renderSummary() {
    var now = new Date();
    var o = E.priceOrder(lines(), state.tier, now);
    ['economy', 'standard', 'rush'].forEach(function (t) {
      var el = document.querySelector('[data-tier-date="' + t + '"]');
      if (!el) return;
      if (!state.parts.length) { el.textContent = t === 'economy' ? '10% off' : t === 'rush' ? '+35 to 40%' : 'base price'; return; }
      var day = E.priceOrder(lines(), t, now).shipDay;
      el.textContent = 'ships ' + E.fmtDay(day).replace(/^\w+, /, '');
    });
    var radio = document.getElementById('tier-' + state.tier);
    if (radio) radio.checked = true;
    els.ship.textContent = o.shipDay ? E.fmtDay(o.shipDay, true) : 'Add a part';
    var rows = [['Parts (' + o.partCount + ')', E.money(o.subtotal)]];
    if (o.smallOrderFee) rows.push(['Top-up to the $' + R.orderMinimum + ' order minimum', E.money(o.smallOrderFee)]);
    rows.push(['Shipping', !state.parts.length ? '—' : o.merchandise >= R.freeShippingThreshold ? 'Free ground' : 'Chosen at checkout']);
    els.lines.innerHTML = rows.map(function (r) { return '<div><span>' + esc(r[0]) + '</span><span class="num">' + esc(r[1]) + '</span></div>'; }).join('');
    els.total.textContent = E.money(o.merchandise);
    var oversized = state.parts.some(function (p) { return !E.fits(p.geo.size, R.materials[p.materialId].maxDims); });
    var quoteOnly = o.lines.some(function (l) { return l.quoteOnly; });
    els.checkout.disabled = !state.parts.length || oversized || quoteOnly || busy;
    els.checkout.textContent = busy ? 'Preparing checkout…' : oversized ? 'Resize or change material to check out'
      : quoteOnly ? 'Over $' + R.priceTiers[R.priceTiers.length - 1].to.toLocaleString('en-US') + ' a part: send a special request' : 'Checkout';
  }

  function updateCard(p) {
    var card = els.parts.querySelector('[data-id="' + p.id + '"]');
    if (!card) return;
    var bits = priceBits(p);
    card.querySelector('[data-line]').textContent = E.money(bits.price.line);
    card.querySelector('[data-each]').textContent = E.money(bits.price.unit) + ' each';
    card.querySelector('[data-breakdown]').textContent = bits.breakdown;
  }

  /* ---------- 3D viewer (three.js) ---------- */
  function initViewer() {
    var T = window.THREE;
    if (!T) { els.empty.textContent = 'The 3D preview didn’t load on this connection. Quoting still works.'; return; }
    try {
      var renderer = new T.WebGLRenderer({ antialias: true, alpha: true });
      renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
      renderer.setClearColor(0x000000, 0);
      els.viewer.insertBefore(renderer.domElement, els.viewer.firstChild);
      renderer.domElement.setAttribute('aria-label', '3D preview of the selected part');
      var scene = new T.Scene();
      var camera = new T.PerspectiveCamera(32, 4 / 3, 0.5, 50000);
      scene.add(new T.HemisphereLight(0xffffff, 0x7d8a96, 0.95));
      var key = new T.DirectionalLight(0xffffff, 0.8); key.position.set(260, 420, 320); scene.add(key);
      var fill = new T.DirectionalLight(0xffffff, 0.3); fill.position.set(-320, -120, -220); scene.add(fill);
      var root = new T.Group(); root.rotation.x = -Math.PI / 2; scene.add(root);
      var controls = T.OrbitControls ? new T.OrbitControls(camera, renderer.domElement) : null;
      if (controls) { controls.enableDamping = true; controls.dampingFactor = 0.1; controls.screenSpacePanning = true; }
      V = { T: T, renderer: renderer, scene: scene, camera: camera, root: root, controls: controls, mesh: null, spin: !reduceMotion };
      var resize = function () {
        var r = els.viewer.getBoundingClientRect();
        var w = Math.max(1, Math.round(r.width)), h = Math.max(1, Math.round(r.height));
        renderer.setSize(w, h, false);
        camera.aspect = w / h;
        camera.updateProjectionMatrix();
      };
      if (window.ResizeObserver) new ResizeObserver(resize).observe(els.viewer); else window.addEventListener('resize', resize);
      resize();
      if (controls) controls.addEventListener('start', function () { V.spin = false; });
      (function loop() {
        requestAnimationFrame(loop);
        if (V.spin && V.mesh) root.rotation.z += 0.0035;
        if (controls) controls.update();
        renderer.render(scene, camera);
      })();
    } catch (e) {
      V = null;
      els.empty.textContent = '3D preview isn’t supported in this browser. Quoting still works.';
    }
  }

  function clearViewer() {
    while (V.root.children.length) {
      var c = V.root.children.pop();
      if (c.geometry) c.geometry.dispose();
      if (c.material) c.material.dispose();
    }
    V.mesh = null;
  }

  function fitCamera(sx, sy, sz) {
    var r = Math.max(8, Math.sqrt(sx * sx + sy * sy + sz * sz) / 2);
    var d = (r / Math.sin((V.camera.fov * Math.PI) / 360)) * 1.12;
    var target = new V.T.Vector3(0, sz / 2, 0);
    V.camera.position.set(d * 0.62, sz / 2 + d * 0.5, d * 0.62);
    V.camera.near = Math.max(0.1, d / 200);
    V.camera.far = d * 60;
    V.camera.updateProjectionMatrix();
    if (V.controls) { V.controls.target.copy(target); V.controls.update(); } else V.camera.lookAt(target);
  }

  function updateHud(p) {
    if (!els.hud) return;
    if (!p) { els.hud.textContent = ''; return; }
    var m = R.materials[p.materialId];
    els.hud.textContent = p.geo.size.map(fmtMM).join(' × ') + ' mm in ' + m.short + ' · build volume ' + m.maxDims.join(' × ') + ' mm';
  }

  function showActive() {
    var p = find(state.active);
    updateHud(p);
    if (!V) return;
    var T = V.T;
    clearViewer();
    if (!p) { els.empty.hidden = false; els.empty.textContent = 'Upload a part to see it in 3D inside the printer’s build volume.'; return; }
    var m = R.materials[p.materialId];
    var css = getComputedStyle(document.documentElement);
    var accent = css.getPropertyValue('--accent').trim() || '#2443e0';
    var gridColor = css.getPropertyValue('--rule-strong').trim() || '#aeb8be';
    var md = m.maxDims;
    var lineMat = new T.LineBasicMaterial({ color: new T.Color(accent), transparent: true, opacity: 0.7 });
    var big = Math.max(p.geo.size[0] / md[0], p.geo.size[1] / md[1], p.geo.size[2] / md[2]) > 0.75;
    var outline;
    if (big) { // large part: show the whole build volume so the fit is visible
      var boxGeo = new T.BoxGeometry(md[0], md[1], md[2]);
      boxGeo.translate(0, 0, md[2] / 2);
      outline = new T.LineSegments(new T.EdgesGeometry(boxGeo), lineMat);
      boxGeo.dispose();
    } else { // small part: just the build plate outline, so box edges don't cut through the view
      outline = new T.LineLoop(new T.BufferGeometry().setFromPoints([[-1, -1], [1, -1], [1, 1], [-1, 1]].map(function (c) {
        return new T.Vector3(c[0] * md[0] / 2, c[1] * md[1] / 2, 0);
      })), lineMat);
    }
    V.root.add(outline);
    var span = Math.max(md[0], md[1]);
    var grid = new T.GridHelper(span, Math.max(4, Math.round(span / 10)), new T.Color(gridColor), new T.Color(gridColor));
    grid.rotation.x = Math.PI / 2;
    grid.material.transparent = true;
    grid.material.opacity = 0.55;
    V.root.add(grid);
    if (!p.positions) {
      els.empty.hidden = false;
      els.empty.textContent = 'Upload ' + p.name + ' again to see it in 3D. Its price is already saved.';
      fitCamera(p.geo.size[0], p.geo.size[1], p.geo.size[2]);
      return;
    }
    els.empty.hidden = true;
    var s = p.unit === 'in' ? 25.4 : p.unit === 'cm' ? 10 : 1;
    var geom = new T.BufferGeometry();
    geom.setAttribute('position', new T.BufferAttribute(p.positions, 3));
    geom.computeVertexNormals();
    geom.computeBoundingBox();
    var bb = geom.boundingBox;
    var mesh = new T.Mesh(geom, new T.MeshStandardMaterial({ color: new T.Color(m.viewerColor), roughness: 0.8, metalness: 0.04, side: T.DoubleSide }));
    mesh.scale.setScalar(s);
    mesh.position.set((-(bb.min.x + bb.max.x) / 2) * s, (-(bb.min.y + bb.max.y) / 2) * s, -bb.min.z * s);
    V.root.add(mesh);
    V.mesh = mesh;
    V.root.rotation.z = 0;
    fitCamera(p.geo.size[0], p.geo.size[1], p.geo.size[2]);
  }

  /* ---------- Shopify cart: one line per part, priced by its unit-price variant ---------- */
  var busy = false;
  function note(text, kind) {
    if (!els.saved) return status(text, kind);
    els.saved.hidden = !text;
    els.saved.className = 'small' + (kind === 'bad' ? ' notice bad' : kind === 'warn' ? ' notice warn' : '');
    els.saved.textContent = text || '';
  }
  /* Look up each unit-price variant through the store's tokenless Storefront API, so the theme never needs a variant map. */
  function optionValue(price) { return '$' + price.toFixed(2); }
  function resolveVariants(reqs) {
    if (!reqs.length) return Promise.resolve([]);
    var q = reqs.map(function (r, i) {
      return 'v' + i + ': product(handle: ' + JSON.stringify(r.handle) + ') { variantBySelectedOptions(selectedOptions: [{ name: ' +
        JSON.stringify(r.option) + ', value: ' + JSON.stringify(optionValue(r.price)) + ' }]) { id availableForSale price { amount } } }';
    }).join(' ');
    return fetch(SHOP.root + 'api/' + (SHOP.apiVersion || '2026-01') + '/graphql.json', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ query: '{ ' + q + ' }' })
    }).then(function (r) { return r.json(); }).then(function (j) {
      return reqs.map(function (r, i) {
        var prod = j && j.data && j.data['v' + i];
        var v = prod && prod.variantBySelectedOptions;
        if (!v || !v.availableForSale || Math.abs(parseFloat(v.price.amount) - r.price) > 0.001) return null;
        return Number(String(v.id).split('/').pop());
      });
    });
  }
  function wait(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }
  function cartPost(path, body, attempt) {
    attempt = attempt || 0;
    var opts = { method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin' };
    if (body instanceof FormData) opts.body = body;
    else { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body || {}); }
    return fetch(SHOP.root + path, opts).then(function (r) {
      if (r.status === 429 && attempt < 4) { // the cart API is rate limited: back off and try again
        var after = parseFloat(r.headers.get('Retry-After')) || 0;
        return wait(Math.max(after * 1000, 1200 * (attempt + 1))).then(function () { return cartPost(path, body, attempt + 1); });
      }
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || 'The cart returned an error (' + r.status + ').'); e.status = r.status; throw e; }
        return j;
      });
    });
  }
  function getBuffer(p) {
    if (p.buffer) return Promise.resolve(p.buffer);
    if (!Store || !Store.getPart || !p.uid) return Promise.resolve(null);
    return Store.getPart(p.uid).then(function (rec) { return rec && rec.buffer ? (p.buffer = rec.buffer) : null; }, function () { return null; });
  }
  /* Shopify accepts cart file uploads up to about 20 MB: compress bigger files, or fall back to an emailed upload link. */
  var CART_FILE_LIMIT = 19.5 * 1024 * 1024;
  function prepareFile(p, buf) {
    if (buf.byteLength <= CART_FILE_LIMIT) return Promise.resolve({ blob: new Blob([buf], { type: 'application/octet-stream' }), name: p.name });
    if (!window.CompressionStream || !window.Response) return Promise.resolve(null);
    try {
      var gz = new Blob([buf]).stream().pipeThrough(new CompressionStream('gzip'));
      return new Response(gz).blob().then(function (b) {
        return b.size <= CART_FILE_LIMIT ? { blob: new Blob([b], { type: 'application/gzip' }), name: p.name + '.gz' } : null;
      }, function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }
  function addLine(x, file, tierName, shipText) {
    var p = x.p, m = R.materials[p.materialId], g = p.geo;
    var fd = new FormData();
    fd.append('id', String(x.variant));
    fd.append('quantity', String(p.qty));
    fd.append('properties[Part]', p.name);
    fd.append('properties[Material]', m.name + ' · ' + m.process);
    fd.append('properties[Finish]', R.finishes[p.finishId].name + (p.finishId === 'vapor' && p.materialId === 'pa11cf' ? ' (pilot)' : ''));
    fd.append('properties[Lead time]', tierName + ', ships by ' + shipText);
    fd.append('properties[Size]', g.size.map(fmtMM).join(' × ') + ' mm' + (p.unit !== 'mm' ? ' (file in ' + p.unit + ')' : ''));
    fd.append('properties[Volume]', (g.volume / 1000).toFixed(2) + ' cm³');
    if (file) fd.append('properties[File]', file.blob, file.name);
    else fd.append('properties[File]', 'We will email you an upload link for ' + p.name);
    fd.append('properties[_quote]', JSON.stringify({
      v: 1, unit: x.price.unit, exact: x.price.exactUnit, qty: p.qty, material: p.materialId, finish: p.finishId,
      tier: state.tier, units: p.unit, volumeCm3: +(g.volume / 1000).toFixed(3), boxCm3: +(g.box / 1000).toFixed(3),
      areaCm2: +(g.area / 100).toFixed(2), watertight: g.watertight, triangles: g.triangles
    }));
    return cartPost('cart/add.js', fd);
  }
  function shopCheckout() {
    if (state.parts.some(function (p) { return p.sample; })) {
      note('Sample parts are only for trying the quote. Remove them, then upload your own files to check out.', 'warn');
      return;
    }
    var order = E.priceOrder(lines(), state.tier, new Date());
    var shipText = E.fmtDay(order.shipDay);
    var tierName = R.tiers[state.tier].name;
    var plan = state.parts.map(function (p, i) { return { p: p, price: order.lines[i] }; });
    var reqs = plan.map(function (x) {
      var tp = x.price.variantTier;
      return { handle: tp ? tp.handle : '', option: 'Unit price', price: x.price.unit };
    });
    if (order.smallOrderFee) reqs.push({ handle: R.topUp.handle, option: 'Amount', price: order.smallOrderFee });
    busy = true;
    renderSummary();
    note('Checking prices…');
    var noFile = [];
    resolveVariants(reqs).then(function (ids) {
      if (ids.some(function (id) { return !id; })) {
        var e = new Error('Checkout isn’t set up for one of these prices yet. Send it as a special request and we’ll quote it by hand.');
        throw e;
      }
      plan.forEach(function (x, i) { x.variant = ids[i]; });
      var top = order.smallOrderFee ? ids[ids.length - 1] : null;
      var chain = cartPost('cart/clear.js', {});
      plan.forEach(function (x, i) {
        chain = chain.then(function () {
          note('Adding ' + x.p.name + ' to the cart (' + (i + 1) + ' of ' + plan.length + ')…');
          return getBuffer(x.p).then(function (buf) { return buf ? prepareFile(x.p, buf) : null; }).then(function (file) {
            if (!file) noFile.push(x.p.name);
            return addLine(x, file, tierName, shipText).catch(function (err) {
              if (!file) throw err;
              noFile.push(x.p.name); // the upload was rejected: add the part and email an upload link
              return addLine(x, null, tierName, shipText);
            });
          });
        });
      });
      if (top) chain = chain.then(function () {
        return cartPost('cart/add.js', { items: [{ id: top, quantity: 1, properties: { Note: 'Brings the order up to the $' + R.orderMinimum + ' minimum' } }] });
      });
      return chain;
    }).then(function () {
      // an empty value removes a cart attribute left over from an earlier checkout attempt
      var attrs = { 'Lead time': tierName, 'Ships by': shipText, 'Files to follow': noFile.join(', ') };
      return cartPost('cart/update.js', { attributes: attrs });
    }).then(function () {
      note('Opening checkout…');
      location.href = SHOP.root + 'checkout';
    }).catch(function (err) {
      busy = false;
      renderSummary();
      note((err && err.message) || 'Something went wrong building the cart. Please try again.', 'bad');
    });
  }

  /* ---------- events ---------- */
  function bind() {
    els.drop.addEventListener('click', function () { els.file.click(); });
    els.file.addEventListener('change', function () { handleFiles(els.file.files); els.file.value = ''; });
    document.addEventListener('dragover', function (e) { e.preventDefault(); els.drop.classList.add('over'); });
    document.addEventListener('dragleave', function (e) { if (!e.relatedTarget) els.drop.classList.remove('over'); });
    document.addEventListener('drop', function (e) {
      e.preventDefault();
      els.drop.classList.remove('over');
      if (e.dataTransfer && e.dataTransfer.files.length) handleFiles(e.dataTransfer.files);
    });
    document.querySelectorAll('[data-sample]').forEach(function (b) {
      b.addEventListener('click', function () { addSample(b.getAttribute('data-sample')); });
    });
    document.querySelectorAll('input[name="tier"]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) { state.tier = r.value; persist(); render(); } });
    });
    els.parts.addEventListener('change', function (e) {
      var card = e.target.closest('.part');
      if (!card) return;
      var p = find(card.getAttribute('data-id'));
      var act = e.target.getAttribute('data-act');
      if (act === 'material') {
        p.materialId = e.target.value;
        if (R.materials[p.materialId].finishes.indexOf(p.finishId) < 0) p.finishId = 'standard';
        state.active = p.id;
      } else if (act === 'finish') p.finishId = e.target.value;
      else if (act === 'qty') p.qty = clampQty(e.target.value);
      persist();
      render();
      if (act === 'material') showActive();
    });
    els.parts.addEventListener('input', function (e) {
      if (e.target.getAttribute('data-act') !== 'qty' || e.target.value === '') return;
      var p = find(e.target.closest('.part').getAttribute('data-id'));
      p.qty = clampQty(e.target.value);
      persist();
      updateCard(p);
      renderSummary();
    });
    els.parts.addEventListener('click', function (e) {
      var card = e.target.closest('.part');
      if (!card) return;
      var p = find(card.getAttribute('data-id'));
      var btn = e.target.closest('button');
      if (btn && btn.getAttribute('data-unit')) {
        p.unit = btn.getAttribute('data-unit');
        p.geo = E.scaledGeo(p.base, p.unit);
        state.active = p.id;
        persist(); render(); showActive();
        return;
      }
      if (btn && btn.getAttribute('data-act') === 'remove') {
        if (Store && Store.deletePart && p.uid) Store.deletePart(p.uid).catch(function () {});
        state.parts = state.parts.filter(function (x) { return x.id !== p.id; });
        if (state.active === p.id) state.active = state.parts.length ? state.parts[state.parts.length - 1].id : null;
        persist(); render(); showActive();
        return;
      }
      if (state.active !== p.id && !e.target.closest('select, input')) {
        state.active = p.id;
        els.parts.querySelectorAll('.part').forEach(function (c) { c.classList.toggle('active', c === card); });
        showActive();
      }
    });
    els.checkout.addEventListener('click', function () {
      persist();
      if (SHOP) shopCheckout(); else location.href = ROUTES.checkout;
    });
    els.save.addEventListener('click', function () {
      if (!state.parts.length) { els.saved.hidden = false; els.saved.textContent = 'Add a part first, then save the quote.'; return; }
      var id = 'Q-' + Date.now().toString(36).toUpperCase().slice(-6);
      var list = Store.load('ls_quotes', []);
      var o = E.priceOrder(lines(), state.tier, new Date());
      list.unshift({ id: id, at: new Date().toISOString(), total: o.merchandise, parts: state.parts.map(function (p) { return p.name; }) });
      var ok = Store.save('ls_quotes', list.slice(0, 20));
      els.saved.hidden = false;
      els.saved.textContent = ok
        ? 'Saved as ' + id + ' on this device. In the live store, saved quotes also appear in your account and inbox for 30 days.'
        : 'This browser blocks saving. In the live store, quotes save to your account instead.';
    });
    if (els.email) els.email.addEventListener('click', function () {
      els.saved.hidden = false;
      els.saved.textContent = 'In the live store this emails a PDF quote with a one-click checkout link. This demo doesn’t send email.';
    });
  }

  /* ---------- start ---------- */
  var params = new URLSearchParams(location.search);
  if (R.materials[params.get('material')]) {
    state.defaultMaterial = params.get('material');
    if (els.defaultNote) { els.defaultNote.hidden = false; els.defaultNote.textContent = 'New uploads default to ' + R.materials[state.defaultMaterial].name + '. You can change it per part.'; }
  }
  restore();
  bind();
  render();
  hydrate();
  initViewer();
  showActive();
  var sampleKey = params.get('sample');
  if (E.SAMPLES[sampleKey] && !state.parts.some(function (p) { return p.sample === sampleKey; })) {
    addSample(sampleKey, R.materials[params.get('material')] ? params.get('material') : null);
  }
  if (Store && Store.takeFile) {
    Store.takeFile().then(function (f) {
      if (f && f.buffer) return handleBuffer(f.name, f.buffer).catch(function (err) { status(err && err.message ? err.message : String(err), 'bad'); });
    }).catch(function () { /* storage blocked: nothing was handed off, so stay quiet */ });
  }
})();
